import { toString } from 'lodash';
import { mapSurveyStylingFromApiModel } from 'styling/api/dataMapper/surveyStylingDataMapper';
import { toAppBlockFormat, omitUndefinedProps } from 'sharedParts';
import { toHeaderBlockFormat } from '../../../api/dataMapper/headerDataMapper';
import { addConditionalLogicActionToBlock } from 'utils/questionLogicUtils';

const mapTakerSurveySettings = ({
  blocked_message,
  end_enabled,
  landing_enabled,
  redirect_url,
  status,
  updated_at,
  is_full_width,
  re_captcha_enabled,
  header_end_enabled,
  header_landing_enabled,
  header_questions_enabled,
  header_uuid,
  is_back_button_enabled,
  is_question_numbering_enabled,
}) =>
  omitUndefinedProps({
    blockedMessage: blocked_message,
    endEnabled: end_enabled,
    landingEnabled: landing_enabled,
    redirectUrl: redirect_url,
    status,
    updatedAt: updated_at,
    isFullWidth: is_full_width,
    reCaptchaEnabled: re_captcha_enabled,
    headerEndEnabled: header_end_enabled,
    headerLandingEnabled: header_landing_enabled,
    headerQuestionsEnabled: header_questions_enabled,
    headerUuid: header_uuid,
    isBackButtonEnabled: is_back_button_enabled,
    questionNumberingEnabled: is_question_numbering_enabled,
  });

export const mapTakerSurveyFromApiModel = ({
  answers_list,
  headers,
  last_clicked_next_button,
  local_styles,
  next_click_count,
  survey_items_list,
  survey_meta,
  survey_response_uuid,
  visited_pages,
  visited_questions,
  ...other
}) => ({
  ...other,
  answerList: answers_list,
  headers: headers.map(toHeaderBlockFormat),
  lastClickedNextButtonId: toString(last_clicked_next_button),
  localStyling: mapSurveyStylingFromApiModel(local_styles),
  nextClickCount: next_click_count,
  responseUuid: survey_response_uuid,
  settings: mapTakerSurveySettings(survey_meta),
  surveyBlockList: survey_items_list.map(toAppBlockFormat).map(addConditionalLogicActionToBlock),
  visitedPages: visited_pages,
  visitedQuestions: visited_questions,
});

export const mapCaptchaVerifyResponse = ({ success, challenge_ts, hostname }) =>
  omitUndefinedProps({
    success,
    challengeTs: challenge_ts,
    hostName: hostname,
  });

export const mapCaptchaVerifyToApiModel = ({ token }) => ({
  response_token: token,
});
